const widget = {
  en: {
    translation: {
      selectLanguage: "Select default language",
      contactBlock: "Contact info",
      contactBlockDescription:
        "Contact information is very important: reservation details will be sent to the following contacts. Insert references that you use often so you won’t lose customers!",
      calendarReservation: "Reservation Calendar",
      calendarReservationDescription:
        "Select times and days available for reservation",
      email: "Email dedicated to reservations",
      telephone: "Telephone number dedicated to reservations",
      reservationButtonStyle: "Personalize widget",
      reservationButtonStyleDescription:
        "You can modify the widget in order to be consistent with the style of your site.",
      label: 'Text to show on the button (e.g. "Book now")',
      width: "Maximum button width (e.g. 200px)",
      backgroundColor: "Button color (e.g. #E6392F)",
      borderColor: "Border color (e.g. #fff)",
      borderRadius: "Round the corners of the button (e.g. 4px)",
      color: "Text color (e.g. #fff)",
      getcode: "Our widget on your site",
      importInHead: "Import the libraries",
      importInHeadDescription:
        "In order to use the widget on your site you will need to import our dedicated libraries. We recommend you to copy the following code at the end of the <head> block of your site",
      importInBody: "Show widget",
      importInBodyDescription:
        "Paste the following code into the <body> block of your site. Our reservation widget will be visible wherever you place it.",
      copy: "copy",
      copiedTitle: "Copied",
      copiedDescription:
        "The code has been copied to your clipboard. Now you can paste it into your site.",
      compulsory_field: "There must be hours available for the reservation",
      error_compulsory_data: "Every data must be filled before saving"
    }
  },
  it: {
    translation: {
      selectLanguage: "Seleziona la lingua di default",
      contactBlock: "Informazioni di contatto",
      contactBlockDescription:
        "Le informazioni di contatto sono molto importanti: tutti gli avvisi relitivi alle prenotazioni saranno inviati ai seguenti contatti. Inserisci dei riferimenti che utilizzi spesso in modo da non perdere clienti!",
      calendarReservation: "Calendario prenotazioni",
      calendarReservationDescription:
        "Seleziona i giorni e gli orari durante i quali sarà possibile ricevere prenotazioni",
      email: "Email dedicata alle prenotazioni",
      telephone: "Numero di cellulare dedicato alle prenotazioni",
      reservationButtonStyle: "Modifica l'aspetto del widget",
      reservationButtonStyleDescription:
        "Puoi modificare l'aspetto del widget in modo da renderlo più in linea con lo stile del tuo sito.",
      label: 'Testo da mostrare sul pulsante (es. "Prenota ora")',
      width: "Larghezza massima del pulsante (es. 200px)",
      backgroundColor: "Colore del pulsante (es. #E6392F)",
      borderColor: "Colore del bordo (es. #fff)",
      borderRadius: "Arrotonda gli angoli del pulsante (es. 4px)",
      color: "Colore del testo (es. #fff)",
      getcode: "Il nostro widget sul tuo sito",
      importInHead: "Importa le librerie",
      importInHeadDescription:
        "Per poter utilizzare il widget sul tuo sito dovrai importare le nostre librerie dedicate. Ti consigliamo di copiare il seguente codice alla fine del blocco <head> del tuo sito",
      importInBody: "Mostra il widget",
      importInBodyDescription:
        "Incolla il seguente codice all'interno del blocco <body> del tuo sito. Ovunque lo posizionerai sarà visibile il nostro widget di prenotazione.",
      copy: "copia",
      copiedTitle: "Copiato",
      copiedDescription:
        "Il codice è stato copiato nei tuoi appunti. Ora puoi incollarlo all'interno del tuo sito.",
      compulsory_field: "Devono esserci orari disponibili per la prenotazione",
      error_compulsory_data:
        "Tutti i dati devono essere compilati prima di salvare"
    }
  }
};

export default widget;
